// extracted by mini-css-extract-plugin
export default {"ControlGroupFix":"ContrastSetting-module__ControlGroupFix--m0jL2"};